import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { multilingualService } from './multilingualService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(multilingualService)
}

export { editor } from './ds'
